import React from "react";
import ReactPaginate from "react-paginate";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import { getReactSelectTheme } from "../../utils/ReactSelectStyles";
import "../../assets/CSS/pagination.css";
import { t } from "i18next";

const CaretDownIcon = () => {
    return <i className="fas fa-chevron-down fa-xs" />;
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <CaretDownIcon />
        </components.DropdownIndicator>
    );
};

const Pagination = ({
    currentPage,
    setCurrentPage,
    totalCount,
    sizePerPage,
    handleItemsPerPage,
    pageSizeFactor = 1,
    width = "55px",
}) => {
    const PAGE_OPTIONS = [
        { value: 10 * pageSizeFactor, label: 10 * pageSizeFactor },
        { value: 20 * pageSizeFactor, label: 20 * pageSizeFactor },
        { value: 30 * pageSizeFactor, label: 30 * pageSizeFactor },
        { value: 40 * pageSizeFactor, label: 40 * pageSizeFactor },
        { value: 50 * pageSizeFactor, label: 50 * pageSizeFactor },
    ];

    if (!totalCount) return <></>;

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "26px",
            height: "26px",
            width: width,
        }),

        valueContainer: (provided) => ({
            ...provided,
            height: "26px",
            padding: "0 4px",
        }),

        input: (provided) => ({
            ...provided,
            margin: "0px",
        }),

        indicatorsContainer: (provided) => ({
            ...provided,
            height: "26px",
        }),
    };

    return (
        <div className="flex items-center justify-between px-2">
            <div className="flex items-center z-1">
                <label className="pagination-ctl uppercase text-dark-gray text-xs mr-2">
                    {t("pageSize")}
                </label>
                <Select
                    menuPlacement="auto"
                    onChange={(e) => handleItemsPerPage(e.value)}
                    isClearable={false}
                    className="w-14 z-98"
                    options={PAGE_OPTIONS}
                    value={PAGE_OPTIONS.filter((p) => p.value === sizePerPage)}
                    name={"itemsPerPage"}
                    theme={getReactSelectTheme}
                    isSearchable={false}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    menuPosition="fixed"
                    menuShouldScrollIntoView={false}
                />
            </div>

            <div className="flex justify-center">
                <ReactPaginate
                    previousLabel={
                        <button
                            className="pagination-btn"
                            disabled={
                                Number(currentPage) === 1 || totalCount === 0
                                    ? "disabled"
                                    : ""
                            }
                            id="pagination-prev-btn"
                        >
                            <i className="fas fa-caret-left"></i>
                        </button>
                    }
                    previousClassName={"pagination-prev"}
                    nextLabel={
                        <button
                            className="pagination-btn"
                            disabled={
                                Number(currentPage) ===
                                    Math.ceil(totalCount / sizePerPage) ||
                                totalCount === 0
                                    ? "disabled"
                                    : ""
                            }
                            id="pagination-next-btn"
                        >
                            <i className="fas fa-caret-right"></i>
                        </button>
                    }
                    nextLabelClassName={"pagination-next"}
                    breakLabel={
                        <button
                            className="pagination-btn without-border"
                            id="pagination-pages-btn"
                        >
                            ...
                        </button>
                    }
                    pageCount={Math.ceil(totalCount / sizePerPage)}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={(curr) => {
                        setCurrentPage(+curr.selected + 1);
                    }}
                    pageLinkClassName={"pagination-btn"}
                    containerClassName={"pagination-numbers flex items-center"}
                    activeLinkClassName={"active"}
                    forcePage={currentPage - 1}
                />
            </div>
        </div>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    setCurrentPage: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    sizePerPage: PropTypes.number.isRequired,
};

export default Pagination;
